import {clampLines} from "../../../../../../../Avency.Nwd.Base/Resources/Private/JavaScript/Project/Clamp";
import PageLoadedQueue from "../../../../../../../Avency.Nwd.Base/Resources/Private/JavaScript/Project/PageLoadedQueue";

/**
 * Make a post request to get the blog posts
 *
 * @param url
 */
const postRequest = async (url: string) => {
    const response = await fetch(url, {
        method: 'GET'
    });

    if (!response.ok) {
        throw new Error('Network response for the posts was not ok. 1712930988');
    }

    return response.text();
}

export function initBlogPosts() {
    const posts: NodeListOf<HTMLElement> = document.querySelectorAll('.blog-posts');

    if (posts.length) {
        posts.forEach((post) => {
            const url = post.dataset.url;

            if (!url) {
                return;
            }

            postRequest(url)
                .then((response) => {
                    post.innerHTML = response;

                    clampLines();
                })
                .catch((error) => {
                    post.innerHTML = post.dataset.errorMessage;
                    console.error('Error:', error);
                });
        });
    }
}

export default initBlogPosts;

PageLoadedQueue.addFunction(initBlogPosts);
